import React, { useEffect } from 'react';
import { Dialog } from '@im/ui-lib/zenith/Dialog';

type Props = {
  description: string;
  enrollmentAppUrl: string;
  handleCancel: () => void;
  handleSuccess: () => void;
  header: string;
  open: boolean;
};

export function FactorEnrollmentPopup(props: Props) {
  const {
    description,
    enrollmentAppUrl,
    handleCancel,
    handleSuccess,
    header,
    open,
  } = props;

  useEffect(() => {
    const func = (event: MessageEvent) => {
      if (event.data === 'close') {
        handleSuccess();
      }
    };
    window.addEventListener('message', func);

    return () => {
      window.removeEventListener('message', func);
    };
  }, [handleSuccess]);

  return (
    <Dialog
      dialogFooterType="horizontal-fill-container"
      dialogHeaderSupportingText={description}
      dialogHeaderText={header}
      handleClose={handleCancel}
      headerDivider={false}
      helpIcon={false}
      open={open}
      showDialogFooter={false}
      showFeaturedIcon={false}
      type="horizontal-left-aligned"
    >
      <iframe
        src={enrollmentAppUrl}
        style={{
          border: 'none',
          height: 'calc(100vh - 200px)',
          width: '100%',
        }}
        title="okta-iframe"
      />
    </Dialog>
  );
}
